export default __webpack_public_path__ + "static/media/crowding.09124d03.png";